import React from 'react';
import { format } from 'date-fns';
import { formatToPriceInDollars } from '../../../utils/FormatValue';
import { IRoute } from '../../../sp-types';

export const OpportunityViewOptions = [
  { text: '1 year', value: 12 },
  { text: '2 years', value: 24 },
  { text: '5 years', value: 60 },
];

export interface PricePoint {
  name: string;
  price: string;
  color: string;
  id: string;
  visible: boolean;
}

export interface IndexRoutes {
  [x: string]: any;
  date: string;
  price?: string;
  futurePrice?: string;
  cost?: string;
  route1?: string;
  route2?: string;
  route3?: string;
}

interface KeyPointsProps {
  routePrices: PricePoint[];
  selectedRoute: string;
}

export const dateAddMonth = (currDate: Date, addMonths: number): Date => {
  return new Date(
    currDate.getFullYear() + Math.floor((currDate.getMonth() + addMonths) / 12),
    (currDate.getMonth() + addMonths) % 12,
    15,
  );
};

const cost = { DELTA: 20, INT_RATE: 0.0025 };

export const isSameMonth = (dateA: Date, dateB: Date): boolean =>
  dateA.getFullYear() === dateB.getFullYear() && dateA.getMonth() === dateB.getMonth();

export const addFuturePriceRoute = (lastPrice: IndexRoutes, showCount: number): IndexRoutes[] =>
  Array.from({ length: showCount }).map((_, i) => ({
    date: dateAddMonth(new Date(), i).toLocaleDateString('en-CA'),
    futurePrice: lastPrice.price,
    cost: (
      +(lastPrice.price || '0') +
      cost.DELTA +
      i * cost.INT_RATE * (+(lastPrice.price || '0') + cost.DELTA)
    ).toString(),
  }));

export const KeyPoints: React.FC<KeyPointsProps> = ({ routePrices, selectedRoute }) => (
  <div className="flex flex-col text-sm min-w-40 gap-3">
    <div className="flex flex-col">
      <p className="text-red  text-lg p-0">Values</p>
    </div>

    {/*<div className="flex flex-col gap-1 ps-2 border-l-4 border-l-purple-300">
      <p className="text-gray-450">Index price</p>
      <p className="p-0">{materialPrice}</p>
    </div>*/}
    {routePrices
      ?.filter(({ visible, price }) => visible && price)
      .map(({ name, price, color, id }, i) => (
        <div
          key={i}
          className="flex w-full flex-col gap-1 ps-2 border-l-4"
          style={{ borderLeftColor: color, borderLeftWidth: selectedRoute === id ? '6px' : '4px' }}
        >
          <p className={id === selectedRoute ? 'text-black font-bold text-nowrap' : 'text-gray-450'}>{name}</p>
          <p className="p-0 text-lg">{formatToPriceInDollars(+price)}</p>
        </div>
      ))}
    <div className="flex flex-1">&nbsp;</div>
  </div>
);

export const getRoutePrice = (price: IndexRoutes, routeId: string): string => price[routeId] || 0;

export const RouteExtraInfo: React.FC<{
  pointPrices?: IndexRoutes;
  currentPrice: IndexRoutes;
  routeId?: string;
  route?: IRoute;
}> = ({ pointPrices, currentPrice, route }) => {
  const futurePoint = pointPrices?.[route?.id || ''] || '';

  // const track = currRoutePrice - +(currentPrice.price || '0');
  // const period = +(routePoint?.price || '') - currRoutePrice;
  const diff = futurePoint && currentPrice?.price ? futurePoint - currentPrice.price : 0;

  return (
    <div className="border-l border-l-gray-200 flex min-w-64 p-1 ps-3 gap-3">
      <div className="flex flex-col p-1 gap-2 min-w-28">
        <p className="text-gray-450 text-sm">Date</p>
        <p>{pointPrices?.date ? format(pointPrices.date, 'MMM yyyy') : '-'}</p>
      </div>
      {/* <div className="flex flex-col p-1 gap-2 min-w-20">
        <p className="text-gray-450 text-sm">C/B</p>
        <p>{formatToPriceInDollars(route?.contago || period)}</p>
      </div> */}
      <div className="flex flex-col p-01 gap-2 min-w-28">
        <p className="text-gray-450 text-sm">Difference</p>
        <b className={`text-lg ${diff > 0 ? 'text-green-300' : 'text-red'}`}>
          {diff ? formatToPriceInDollars(diff) : '-'}
        </b>
      </div>
    </div>
  );
};
